import { get, omit } from "lodash";
import { CrossGroupPermission, PermissionsGroup } from "PFTypes";

import { FormData } from "./permissions_group_edit_page.types";

const setAccessLevel = (
  permissionsGroup: FormData | CrossGroupPermission,
  id: number,
  level: string,
  name: string[]
) => {
  const levels = { ...get(permissionsGroup, name) } || {};

  if (level === "hidden" || !level) {
    return omit(levels, id);
  }

  return {
    ...levels,
    [id]: level
  };
};

const setCrossGroupPermissions = (
  permissionsGroup: FormData,
  groupId: number,
  field: number,
  level: string,
  categoryId: string
): Pick<PermissionsGroup, "cross_group_permissions"> => {
  const cgPerms = permissionsGroup.cross_group_permissions || {};

  const levels = setAccessLevel(cgPerms[groupId], field, level, [categoryId]);

  return {
    cross_group_permissions: {
      ...cgPerms,
      [groupId]: {
        ...cgPerms[groupId],
        [categoryId]: levels
      }
    }
  };
};

export const setCustomTypeAccessLevel = (
  type,
  permissionsGroup,
  categoryId,
  level
): Pick<PermissionsGroup, "custom_types_access_levels"> => ({
  custom_types_access_levels: {
    ...permissionsGroup.custom_types_access_levels,
    [type]: setAccessLevel(permissionsGroup, categoryId, level, ["custom_types_access_levels", type])
  }
});

export const setBookingCategoriesAccessLevel = (
  permissionsGroup: FormData,
  categoryId: number,
  level: string
): Pick<PermissionsGroup, "booking_categories_access_levels"> => ({
  booking_categories_access_levels: setAccessLevel(permissionsGroup, categoryId, level, [
    "booking_categories_access_levels"
  ])
});

export const setCrossGroupCustomType = (
  permissionsGroup: FormData,
  groupId: number,
  ctId: number,
  level: string
): Pick<PermissionsGroup, "cross_group_permissions"> =>
  setCrossGroupPermissions(permissionsGroup, groupId, ctId, level, "custom_types_access_levels");

export const setCrossGroupActivityType = (
  permissionsGroup: FormData,
  groupId: number,
  atId: number,
  level: string
): Pick<PermissionsGroup, "cross_group_permissions"> =>
  setCrossGroupPermissions(permissionsGroup, groupId, atId, level, "activities_access_levels");

export const setCrossGroupProfileField = (
  permissionsGroup: FormData,
  groupId: number,
  field: number,
  level: string
): Pick<PermissionsGroup, "cross_group_permissions"> =>
  setCrossGroupPermissions(permissionsGroup, groupId, field, level, "profile_fields_access_levels");
